import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-slider-showroom',
    templateUrl: './showroom-exhibit-slider-page.component.html',
    styleUrls: ['./showroom-exhibit-slider-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitSliderPageComponent {

}
